import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from '../../../i18n/keys-to-translate';

@Pipe({
  name: 'gwrBaujahrPeriodePipe',
  pure: false
})
export class GwrBaujahrPeriodePipe implements PipeTransform {
  private BAUPERIODE_PREFIX = 'GWRBAUPERIODE_';

  constructor(private translate: TranslateService) {
    keysToTranslate<string>([
      'GWRBAUPERIODE_8011',
      'GWRBAUPERIODE_8012',
      'GWRBAUPERIODE_8013',
      'GWRBAUPERIODE_8014',
      'GWRBAUPERIODE_8015',
      'GWRBAUPERIODE_8016',
      'GWRBAUPERIODE_8017',
      'GWRBAUPERIODE_8018',
      'GWRBAUPERIODE_8019',
      'GWRBAUPERIODE_8020',
      'GWRBAUPERIODE_8021',
      'GWRBAUPERIODE_8022',
      'GWRBAUPERIODE_8023'
    ]);
  }

  transform(baujahr?: number, bauperiode?: number): string {
    const result = [];

    if (baujahr) {
      result.push(baujahr);
    } else {
      result.push(this.capitalizeFirstLetter(this.translate.instant('undefined')));
    }

    if (bauperiode) {
      const lookupPeriode = this.translate.instant(this.BAUPERIODE_PREFIX + bauperiode);
      if (lookupPeriode) {
        result.push('('.concat(lookupPeriode).concat(')'));
      }
    }

    return result.join(' ');
  }

  capitalizeFirstLetter(value: string) {
    if (!value || value.length === 1) {
      return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
